import { Component, OnInit, Inject, ElementRef, Renderer2 } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ShopSettingsService } from '../../modules/general/services/shop-settings.service';

@Component({
  selector: 'app-page-agb-popup',
  templateUrl: './page-agb-popup.component.html',
  styleUrls: ['./page-agb-popup.component.css']
})
export class PageAgbPopupComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<PageAgbPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private ref: ElementRef,
    public shopSettingsService: ShopSettingsService,
    private renderer: Renderer2,
  ) { }

  ngOnInit(): void {
    if (this.shopSettingsService.isVUMode) {
      this.renderer.addClass(this.ref.nativeElement, 'vu-mode');
    }
  }

  closeClick(): void {
    this.dialogRef.close();
  }

  onCloseClick(): void {
    this.closeClick();
  }

}
